<template>
   <router-view v-if="source"
               :source="source"
               :source-shares="sourceShares"
               :share="currentShare"
               :program="program"
               :pendingEdition="pendingEdition"
               ref="innerComponent"
               @commit="commit"
               @updateCom="updateCom"
               @saveAdv="saveAdv"
               @changePanel="changePanel"
               @updateCurrentShare="updateCurrentShare"
               @backToInitialShares="$emit('backToInitialShares')"
               @editAdv="val => $emit('editAdv', val)"
  ></router-view>
</template>

<script>
  import Commercialisation from './Commercialisation'
  import Facturation from './Facturation'
  import { mapGetters } from 'vuex'
  import { AdvMx } from '@/mixins'

  const PANELS = Object.freeze({
    COMMERCIALISATION: 'Commercialisation',
    FACTURATION: 'SellerFacturation'
  })

  export default {
    name: 'CommercialisationFacturation',
    components: {Commercialisation, Facturation},
    mixins: [AdvMx],
    props: {},
    data () {
      return {
        PANELS,
        panel: PANELS.COMMERCIALISATION,
        currentShare: null
      }
    },
    watch: {
      sourceShares (v) {
        if (this.currentShare) {
          let newCurrentShare = v.find(x => x.seller === this.currentShare.seller)
          this.updateCurrentShare(newCurrentShare)
        }
      }
    },
    computed: {
      ...mapGetters(['isAdmin']),
      panelComponent () {
        const components = {
          [PANELS.COMMERCIALISATION]: 'Commercialisation',
          [PANELS.FACTURATION]: 'Facturation'
        }
        return components[this.panel]
      }
    },
    methods: {
      changePanel ({panel, share}) {
        // this.panel = panel
        let route = {name: PANELS[panel]}
        if (share) {
          route.params = {seller_id: share.seller}
        }
        this.$router.push(route)
        this.currentShare = share
      },
      commit () {
        this.$emit('commit')
      },
      updateCom () {
        this.$emit('updateCom')
      },
      saveAdv (value) {
        this.$emit('saveAdv', value)
      },
      updateCurrentShare (val) {
        this.currentShare = val
      }
    },
    created () {
      if (this.$route.name === 'SellerFacturation' && !this.currentShare) {
        this.currentShare = this.sourceShares.find(x => x.seller === this.$route.params.seller_id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/Commercialisation/CommercialisationFacturation.vue